import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    name: 'Der Schnellstart-Kompass',
    price: '19 €',
    image: 'https://cdn.magicpatterns.com/uploads/ktnEB4evrEgGHx6ZKKaKUh/ChatGPT_Image_14_jul_2026,_15_02_35.png'
  }, {
    name: 'Der Gewohnheits-Baumeister',
    price: '36 €',
    image: 'https://cdn.magicpatterns.com/uploads/ePcaBWBJXL59szgWH8pTDp/ChatGPT_Image_14_jul_2026,_15_03_46.png'
  }, {
    name: 'Der Verspannungs-Code',
    price: '19 €',
    image: 'https://cdn.magicpatterns.com/uploads/nhSMMJD8iqz2Yv5Yh64T6S/ChatGPT_Image_14_jul_2026,_15_05_40.png'
  }, {
    name: 'Der Unterrichts-Meister',
    price: '27 €',
    image: 'https://cdn.magicpatterns.com/uploads/dceKjDyExKsozQqDLtKrAy/ChatGPT_Image_14_jul_2026,_15_07_06.png'
  }, {
    name: 'Der Wissenschafts-Kompass',
    price: '27 €',
    image: 'https://cdn.magicpatterns.com/uploads/isuu9amPtuNthrKSQ85Hnt/ChatGPT_Image_14_jul_2026,_15_10_30.png'
  }];
  return <section className="bg-brand-cream px-4 py-20" data-id="element-23">
      <div className="mx-auto max-w-3xl" data-id="element-24">
        <div className="mb-12 text-center" data-id="element-25">
          <h2 className="mb-4 text-3xl font-black text-brand-text md:text-4xl" data-id="element-26">
            🎁 5 Exklusive Boni
          </h2>
          <p className="text-brand-gray" data-id="element-27">
            Im Wert von{' '}
            <span className="font-bold text-brand-terracotta line-through" data-id="element-28">
              95 €
            </span>{' '}
            — <strong className="text-brand-text" data-id="element-29">FREI</strong> enthalten
          </p>
        </div>

        <div className="space-y-4" data-id="element-30">
          {bonuses.map((bonus, index) => <article key={bonus.name} className="flex items-center gap-4 rounded-2xl border border-brand-creamDark bg-white p-4 shadow-sm md:gap-6 md:p-6" data-id="element-31">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-green text-sm font-bold text-white md:h-10 md:w-10 md:text-base" data-id="element-32">
                {index + 1}
              </div>
              <img src={bonus.image} alt={`Cover von ${bonus.name}`} className="h-16 w-12 shrink-0 rounded-lg border border-brand-creamDark object-cover object-center shadow-sm md:h-20 md:w-14" data-id="element-33" />
              <div className="min-w-0 flex-1" data-id="element-34">
                <h3 className="mb-1 text-sm font-bold text-brand-text md:text-base" data-id="element-35">
                  {bonus.name}
                </h3>
                <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-36">
                  <span className="font-medium text-brand-terracotta line-through" data-id="element-37">
                    {bonus.price}
                  </span>
                  <span className="font-bold text-brand-green" data-id="element-38">FREI</span>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}